export default __webpack_public_path__ + "static/media/TUM_Logo_extern_mt_DE_RGB_neg_s.7cb6e25d.svg";